import { render } from "./SearchParaclinical.vue?vue&type=template&id=66f35efe&scoped=true&ts=true"
import script from "./SearchParaclinical.vue?vue&type=script&lang=ts"
export * from "./SearchParaclinical.vue?vue&type=script&lang=ts"

import "./SearchParaclinical.vue?vue&type=style&index=0&id=66f35efe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66f35efe"]])

export default __exports__